import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-d-flex p-flex-row" }
const _hoisted_2 = { class: "p-col-3" }
const _hoisted_3 = { class: "kn-list-item" }
const _hoisted_4 = { class: "kn-list-item-text" }
const _hoisted_5 = { class: "p-col-9" }
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "pi pi-pencil edit-icon" }, null, -1)
const _hoisted_7 = { class: "p-mr-2" }
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "pi pi-pencil edit-icon" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("i", { class: "pi pi-pencil edit-icon" }, null, -1)
const _hoisted_10 = { class: "p-mr-2" }
const _hoisted_11 = /*#__PURE__*/_createVNode("i", { class: "pi pi-pencil edit-icon" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Listbox = _resolveComponent("Listbox")
  const _component_Column = _resolveComponent("Column")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Button = _resolveComponent("Button")
  const _component_DataTable = _resolveComponent("DataTable")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('managers.lovsManagement.fields')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_Listbox, {
        class: "kn-list",
        options: _ctx.data,
        listStyle: _ctx.lovsManagementTreeDescriptor.listBox.style,
        filter: true,
        filterPlaceholder: _ctx.$t('common.search'),
        optionLabel: "name",
        filterMatchMode: "contains",
        filterFields: _ctx.lovsManagementTreeDescriptor.filterFields,
        emptyFilterMessage: _ctx.$t('common.info.noDataFound'),
        onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setSelectedValue($event.value)))
      }, {
        empty: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
        ]),
        option: _withCtx((slotProps) => [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("span", null, _toDisplayString(slotProps.option.name), 1)
            ])
          ])
        ]),
        _: 1
      }, 8, ["options", "listStyle", "filterPlaceholder", "filterFields", "emptyFilterMessage"])
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('managers.lovsManagement.definition')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_DataTable, {
        value: _ctx.selectedValues,
        class: "p-datatable-sm kn-table",
        editMode: "cell",
        responsiveLayout: "stack",
        breakpoint: "960px",
        onCellEditComplete: _ctx.onCellEditComplete
      }, {
        empty: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            class: "kn-truncated",
            field: "level",
            header: _ctx.$t('managers.lovsManagement.level')
          }, null, 8, ["header"]),
          _createVNode(_component_Column, {
            class: "kn-truncated p-mr-2",
            field: "value",
            header: _ctx.$t('managers.lovsManagement.value')
          }, {
            editor: _withCtx((slotProps) => [
              _createVNode(_component_Dropdown, {
                class: "p-mr-2",
                modelValue: slotProps.data[slotProps.column.props.field],
                "onUpdate:modelValue": ($event: any) => (slotProps.data[slotProps.column.props.field] = $event),
                modelModifiers: { trim: true },
                optionLabel: "name",
                optionValue: "name",
                options: _ctx.options
              }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]),
              _hoisted_6
            ]),
            body: _withCtx((slotProps) => [
              _createVNode("span", _hoisted_7, _toDisplayString(slotProps.data.value), 1),
              _hoisted_8
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            class: "kn-truncated p-mr-2",
            field: "description",
            header: _ctx.$t('managers.lovsManagement.description')
          }, {
            editor: _withCtx((slotProps) => [
              _createVNode(_component_Dropdown, {
                class: "p-mr-2",
                modelValue: slotProps.data[slotProps.column.props.field],
                "onUpdate:modelValue": ($event: any) => (slotProps.data[slotProps.column.props.field] = $event),
                modelModifiers: { trim: true },
                optionLabel: "name",
                optionValue: "name",
                options: _ctx.options
              }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]),
              _hoisted_9
            ]),
            body: _withCtx((slotProps) => [
              _createVNode("span", _hoisted_10, _toDisplayString(slotProps.data.description), 1),
              _hoisted_11
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            style: _ctx.lovsManagementTreeDescriptor.table.iconColumn.style
          }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_Button, {
                icon: "pi pi-trash",
                class: "p-button-link",
                onClick: ($event: any) => (_ctx.removeValueConfirm(slotProps.index))
              }, null, 8, ["onClick"])
            ]),
            _: 1
          }, 8, ["style"])
        ]),
        _: 1
      }, 8, ["value", "onCellEditComplete"])
    ])
  ]))
}